import { errorAlert } from "../actions/alert.js";

export const auth = {
  SUSPENSE: "SUSPENSE",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_FAILURE: "FETCH_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  UPDATE_SUCCESS: "UPDATE_SUCCESS",
  LOGOUT: "LOGOUT"
};

export const alertActions = {
  ALERT_SHOW: "ALERT_SHOW",
  ALERT_HIDE: "ALERT_HIDE"
};

export const caseActions = {
  ADD: "ADD",
  REMOVE: "REMOVE",
  RELOAD: "RELOAD",
  ERROR: "ERROR",
  SELECT: "SELECT"
}

export const snackbarActions = {
  SHOW: "SHOW",
  HIDE: "HIDE"
}

export function handleAxiosError(error, dispatch) {
  const res = error.response?.data;
  if (dispatch) {
    dispatch(errorAlert(res?.error || error.message));
  } else {
    alert(res?.error || error.message);
  }
}
